import script from "./StreamFormPage.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamFormPage.vue?vue&type=script&setup=true&lang=js"

import "./StreamFormPage.vue?vue&type=style&index=0&id=016e41e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-016e41e6"]])

export default __exports__